'use client';

import Image from 'next/image';
import { useState } from 'react';
import PopupForm from '@/components/ui/PopupForm';

const items = [
  {
    title: '£35 per person',
    img: '/images/service-2.webp',
    anchor: 'service-2',
  },
  {
    title: 'Book',
    img: '/images/service-1.webp',
    anchor: 'service-1',
  },
  {
    title: '£20 per child',
    img: '/images/service-3.webp',
    anchor: 'service-3',
  },
];

export default function FeaturedCollections() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section data-component-id="src/components/ui/FeaturedCollections.tsx:30:6" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="30" data-component-end-line="67" data-component-file="FeaturedCollections.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-8%20md%3Apy-12%20lg%3Apy-16%22%7D" className="py-8 md:py-12 lg:py-16">
        <div data-component-id="src/components/ui/FeaturedCollections.tsx:31:8" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="31" data-component-end-line="66" data-component-file="FeaturedCollections.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mx-auto%20max-w-7xl%20px-6%20text-center%22%7D" className="mx-auto max-w-7xl px-6 text-center">
          <h2 data-component-id="src/components/ui/FeaturedCollections.tsx:32:10" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="32" data-component-end-line="34" data-component-file="FeaturedCollections.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mb-10%20font-cormorant%20text-%5B45px%5D%20md%3Atext-%5B64px%5D%20italic%20leading-none%22%2C%22textContent%22%3A%22Our%20services%22%7D" className="mb-10 font-cormorant text-[45px] md:text-[64px] italic leading-none">
            Our services
          </h2>

          <div data-component-id="src/components/ui/FeaturedCollections.tsx:36:10" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="36" data-component-end-line="65" data-component-file="FeaturedCollections.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20gap-10%20md%3Agrid-cols-3%22%7D" className="grid grid-cols-1 gap-10 md:grid-cols-3">
            {items.map((item) => (
              <div data-component-id="src/components/ui/FeaturedCollections.tsx:38:14" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="38" data-component-end-line="63" data-component-file="FeaturedCollections.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" key={item.anchor}>
                <Image data-component-id="src/components/ui/FeaturedCollections.tsx:39:16" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="39" data-component-end-line="45" data-component-file="FeaturedCollections.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22mb-6%20w-full%20object-cover%22%7D"
                  src={item.img}
                  alt={item.title}
                  width={400}
                  height={400}
                  className="mb-6 w-full object-cover"
                />

                <button data-component-id="src/components/ui/FeaturedCollections.tsx:47:16" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="47" data-component-end-line="62" data-component-file="FeaturedCollections.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20mt-8%20border%20rounded-%5B2px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20px-6%20py-3%20sm%3Apx-8%20sm%3Apy-4%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20font-roboto%20font-medium%20uppercase%20leading-none%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-%5B12px%5D%20sm%3Atext-%5B18px%5D%20lg%3Atext-%5B20px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-%5B%23EEF5F1%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20shadow-%5B0_0_20px_5px_rgba(238%2C245%2C241%2C0.5)%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20transition%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20hover%3Aopacity-60%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20animate-pulse-slow%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
                  onClick={() => setOpen(true)}
                  className="
                    mt-8 border rounded-[2px]
                    px-6 py-3 sm:px-8 sm:py-4
                    font-roboto font-medium uppercase leading-none
                    text-[12px] sm:text-[18px] lg:text-[20px]
                    bg-[#EEF5F1]
                    shadow-[0_0_20px_5px_rgba(238,245,241,0.5)]
                    transition
                    hover:opacity-60
                    animate-pulse-slow
                  "
                >
                  {item.title}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PopupForm data-component-id="src/components/ui/FeaturedCollections.tsx:69:6" data-component-path="src/components/ui/FeaturedCollections.tsx" data-component-line="69" data-component-end-line="69" data-component-file="FeaturedCollections.tsx" data-component-name="PopupForm" data-component-content="%7B%22elementName%22%3A%22PopupForm%22%7D" isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
